import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '..';
export var StyledStandardTagLight = function StyledStandardTagLight(props) {
  return "\n    color: ".concat(props.theme.components.standardTag.lightColor, ";\n");
};
export var StyledStandardTagDark = function StyledStandardTagDark(props) {
  return "\n    color: ".concat(props.theme.components.standardTag.darkColor, ";\n");
};
export var StyledIcon = styled(Icon)(_templateObject());
export var StyledStandardTag = styled.div(_templateObject2(), function (props) {
  return "\n        display: inline-block;\n        font-family: ".concat(props.theme.components.standardTag.fontFamily, ";\n        font-size: ").concat(props.theme.components.standardTag.fontSize, ";\n        font-weight: ").concat(props.theme.components.standardTag.fontWeight, ";\n        line-height: ").concat(props.theme.components.standardTag.lineHeight, ";\n\n        ").concat(props.light ? StyledStandardTagLight(props) : StyledStandardTagDark(props), "\n    ");
});